import { create } from 'zustand'

const useStore = create((set) => ({

    status: 'ready',

    items: [],

    orientation: 'L',

    picture: {
        url: null,
        name: null
    },

    selectedItem: null,

    setStatus: (status) => set(state => {

        return {...state, status}
    }),

    resetItems: () => set(state => {

        return {...state, items: defaultItems}
    }),

    setItems: items => set(state => {

        return {...state, items, status: 'changed'}
    }),

    moveItem: (id, deltaX, deltaY) => set(state => {

        let item = state.items.find(i => i.id === id)

        let newItem = {...item}
        newItem.x = item.x + deltaX
        newItem.y = item.y + deltaY

        let newItems = [...state.items].filter(i => i.id !== id)

        newItems.push(newItem)

        return {...state, items: newItems, status: 'changed'}
    }),

    addItem: text => set(state => {

        let newItems = [...state.items];

        newItems.push({
            id: Date.now().toString(),
            text: text,
            x: 1,
            y: 1,
        })

        return {...state, items: newItems, status: 'changed'}
    }),

    removeItem: id => set(state => {

        let newItems = [...state.items].filter(i => i.id !== id);

        return {...state, items: newItems, status: 'changed'}
    }),

    selectItem: id => set(state => {

        let selectedItem = state.items.find(i => i.id === id) || null;

        return {...state, selectedItem}
    }),

    deselectItem: () => set(state => {

        return {...state, selectedItem: null}
    }),

    setOrientation: orientation => set(state => {

        return {...state, orientation, status: 'changed'}
    }),

    setPicture: picture => set(state => {

        return {...state, picture}
    }),

    resetPicture: () => set(state => {

        return {...state, picture: {
            url: null,
            name: null
        }, status: 'changed'}
    }),

    reset: () => set(state => {

        return {...state, 
            picture: {
                url: null,
                name: null
            },
            items: defaultItems,
            orientation: 'L',
            status: 'ready',
            selectedItem: null
        }

    }),

    setup: (data) => set(state => {

        let copy = {...state, status: 'saved'}

        Object.assign(copy, data)

        return copy
    }),

}))


const defaultItems = [
    {
        id: "name",
        text: "{lastname} {firstname}",
        x: 1,
        y: 1
    },
    {
        id: "title",
        text: "{course}",
        x: 1,
        y: 11
    },
    {
        id: "date",
        text: "{date}",
        x: 1,
        y: 21
    },
    {
        id: "number",
        text: "{num}",
        x: 1,
        y: 31
    }
];

export default useStore;